export const TAB_REGISTERED = 'REGISTERED';
export const TAB_LOST_WON_PAID_OUT = 'LOST_WON_PAID_OUT';
export const TAB_CASHIN = 'CASHIN';
export const TAB_SAVED = 'SAVED';

export const TABS = {
    TAB_REGISTERED,
    TAB_LOST_WON_PAID_OUT,
    TAB_CASHIN,
    TAB_SAVED
};
